import Nav from "react-bootstrap/Nav";
import "./Navbar.css";

const Navbar = () => {
    return (
        <>
            <Nav className="justify-content-center navbar ">
                <Nav.Item>
                    <Nav.Link className="text-white nav-heading">Home</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        className="text-white nav-heading"
                        href="https://www.nikhilnambi.in"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Other Services
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </>
    );
};

export default Navbar;
